module.exports = __webpack_public_path__ + "img/main02.64bc15f9.jpg";